<template>
    <div class="content-image"
        :style="{ 'justify-content' : userMessageList.length >= 5 ? 'start' : 'center' }">
        <div v-for="(item,index) in userMessageList"
            :key="index"
            class="content-image-item">
            <div class="content-image-item-img">
                <img v-if="item.userHeadPortraitUrl"
                    :src="item.userHeadPortraitUrl">
                <img v-else
                    src="static/runtime/images/magic/award/userImg.png"
                    alt="" />
            </div>
            <div class="content-image-item-text">{{ item.anonymizedText }}</div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    userMessageList: Array
  },
};
</script>
<style lang="scss" scoped>
.content-image {
    display: flex;
    width: 85%;
    margin: 0.6vh auto 0;
    flex-wrap: wrap;
    .content-image-item {
    width: 20%;
    margin-top: 1.3vh;
    .content-image-item-img {
        position: relative;
        margin-left: 10%;
        width: 80%;
        height: 0;
        padding-top: 80%;
        border-radius: 50%;
        overflow: hidden;
        img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        }
    }
    .content-image-item-text {
        margin-top: 1vh;
        height: 16px;
        font-size: 12px;
        font-weight: 200;
        overflow: hidden;
    }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/public/header-list.vue